class Quotation {
  constructor(id, opportunityId, productLines) {
    this._id = id;
    this._opportunityId = opportunityId;
    this._productLines = productLines || [];
  }

  getId() {
    return this._id;
  }

  getOpportunityId() {
    return this._opportunityId;
  }

  getProductLines() {
    return this._productLines;
  }

  setId(newId) {
    this._id = newId;
    return this;
  }

  setOpportunityId(newOpportunityId) {
    this._opportunityId = newOpportunityId;
    return this;
  }

  setProductLines(newProductLines) {
    this._productLines = newProductLines;
    return this;
  }

  serialize() {
    return { ...this, '@type': 'Quotation' };
  }

  clone() {
    return new Quotation(this._id, this._opportunityId, this._productLines);
  }

  static deserialize(raw) {
    return new Quotation(raw._id, raw._opportunityId, raw._productLines);
  }
}

export default Quotation;



// WEBPACK FOOTER //
// ./src/models/SFModels/Quotation.js